<template>
    <v-dialog v-model="show" @click:outside="close" width="785px">
        <div class="modal">
            <v-row>
                <div class="icon-modal table-cell">
                    <v-layout class="align-center">
                        <v-flex>
                            <img :src="require('@/assets/img/warning.svg')" alt=""/>
                        </v-flex>
                    </v-layout>
                </div>
                <v-col class="table-cell modal-content">
                    <div class="d-flex justify-space-between">
                        <h6 class="modal-title mb-5">Send Push Notification</h6>
                    </div>
                    Are you sure you wish to send this push notification out to the {{total_contacts}} contacts selected?
                    <div class="mt-8 mb-9 buttons d-flex">
                        <v-btn
                                class="btn-blanco few mt-5 mr-6"
                                rounded
                                depressed
                                @click="click"
                                style="width:160px"
                        >Yes
                        </v-btn>
                        <v-btn
                                class="btn-azul few mt-5"
                                rounded
                                depressed
                                @click="cancel"
                                style="width:160px"
                        >No
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-dialog>
</template>

<script>
    import {mapState} from "vuex";
    export default {
        props: ['show', 'hide', 'click', 'cancel'],
        data: () => ({
            image: require("@/assets/logo.svg")
        }),
        computed: {
            ...
                mapState({
                    total_contacts: state => state.Push_notifications.total_contacts
                })
        },
        components: {},
        methods: {
            close: function () {
                this.hide();
            }
        },
    };
</script>
